import UIStatusTag from 'UIComponents/tag/UIStatusTag';
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import useContentCrmObject from '../publishing/hooks/useContentCrmObject';
import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentPublishStatus = ({
  isPublished,
  isScheduled,
  publishDate,
  scheduledUpdateDate,
  unpublishDate,
  unpublishEnabled
}) => {
  const {
    isContentCrmObjectPublished,
    isContentCrmObjectScheduled,
    isContentCrmObjectScheduledToBeUnpublished,
    isContentCrmObjectPublishedWithScheduledUpdate,
    contentCrmObject,
    isContentCrmObjectLoading,
    canScheduleWithContentCrmObject
  } = useContentCrmObject();
  const publishStatusOptions = useMemo(() => {
    let publishStatusLangKey = 'draft';
    let statusTagUse = 'draft';
    if (canScheduleWithContentCrmObject) {
      if (isContentCrmObjectLoading) {
        publishStatusLangKey = undefined;
        statusTagUse = undefined;
      } else if (isContentCrmObjectPublished) {
        if (isContentCrmObjectPublishedWithScheduledUpdate) {
          publishStatusLangKey = 'publishedWithScheduledUpdate';
        } else if (isContentCrmObjectScheduledToBeUnpublished) {
          publishStatusLangKey = 'publishedUntil';
        } else {
          publishStatusLangKey = 'published';
        }
        statusTagUse = 'published';
      } else if (isContentCrmObjectScheduled) {
        publishStatusLangKey = 'scheduled';
        statusTagUse = 'scheduled';
      }
    } else {
      if (isPublished) {
        if (scheduledUpdateDate) {
          publishStatusLangKey = 'publishedWithScheduledUpdate';
        } else if (unpublishDate && unpublishEnabled) {
          publishStatusLangKey = 'publishedUntil';
        } else {
          publishStatusLangKey = 'published';
        }
        statusTagUse = 'published';
      } else if (isScheduled) {
        publishStatusLangKey = 'scheduled';
        statusTagUse = 'scheduled';
      }
    }
    const contentCrmObjectScheduledPublishDate = isContentCrmObjectScheduled ? getContentPropertyValue(contentCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_PUBLISH_DATE) : null;
    const contentCrmObjectScheduledUnpublishDate = isContentCrmObjectScheduledToBeUnpublished ? getContentPropertyValue(contentCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_UNPUBLISH_DATE) : null;
    const contentCrmObjectScheduledUpdateDate = isContentCrmObjectPublishedWithScheduledUpdate ? getContentPropertyValue(contentCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_PUBLISH_DATE) : null;
    const scheduledPublishDate = contentCrmObjectScheduledPublishDate || publishDate;
    const scheduledUnpublishDate = contentCrmObjectScheduledUnpublishDate || unpublishDate;
    const scheduledUpdateDateWhenPublished = contentCrmObjectScheduledUpdateDate || scheduledUpdateDate;
    const scheduledTime = scheduledPublishDate ? I18n.moment(scheduledPublishDate)
    // @ts-expect-error portalTz() isn't typed
    .portalTz().format('LLL') : undefined;
    const unpublishTime = scheduledUnpublishDate ? I18n.moment(scheduledUnpublishDate)
    // @ts-expect-error portalTz() isn't typed
    .portalTz().format('LLL') : undefined;
    const scheduledUpdateTime = scheduledUpdateDateWhenPublished ? I18n.moment(scheduledUpdateDateWhenPublished)
    // @ts-expect-error portalTz() isn't typed
    .portalTz().format('LLL') : undefined;
    return {
      dateOptions: {
        scheduledTime,
        unpublishTime,
        scheduledUpdateTime
      },
      publishStatusLangKey,
      statusTagUse
    };
  }, [canScheduleWithContentCrmObject, contentCrmObject, isContentCrmObjectLoading, isContentCrmObjectPublished, isContentCrmObjectPublishedWithScheduledUpdate, isContentCrmObjectScheduled, isContentCrmObjectScheduledToBeUnpublished, isPublished, isScheduled, publishDate, scheduledUpdateDate, unpublishDate, unpublishEnabled]);
  if (!publishStatusOptions.publishStatusLangKey || !publishStatusOptions.statusTagUse) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIStatusTag, {
    use: publishStatusOptions.statusTagUse,
    children: /*#__PURE__*/_jsx(Text, {
      as: "span",
      color: "text-core-on-fill-default",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `components.header.publishStatus.${publishStatusOptions.publishStatusLangKey}`,
        options: publishStatusOptions.dateOptions
      })
    })
  });
};
export default ContentPublishStatus;